module.exports = __webpack_public_path__ + "img/acri-logo.6bf9a8be.jpg";